import SEO from "./SEO";
import HeaderHome from "./HeaderHome";
import FooterHome from "./FooterHome";
import { StickyOrgNavbar } from "../OrgNavbar";

export default function GtmBlueprintLoadingShell() {
  return (
    <div
      className="flex min-h-screen flex-col bg-gray-50 text-gray-900 dark:bg-gray-900 dark:text-white"
      data-testid="gtm-blueprint-loading-shell"
    >
      <SEO title="Create Your GTM Blueprint" noIndex />
      <StickyOrgNavbar />
      <HeaderHome heading="Create Your GTM Blueprint" />
      <main
        className="mx-auto flex w-full max-w-5xl flex-1 flex-col px-4 pb-6 sm:px-6 sm:pb-8"
        aria-busy="true"
        aria-live="polite"
      >
        <div className="mb-6 flex gap-2 border-b border-gray-200 pb-2 dark:border-white/10">
          <span className="rounded-full bg-darkPurple px-5 py-2 text-sm font-semibold text-white">Generate</span>
          <span className="rounded-full border border-darkPurple px-5 py-2 text-sm font-semibold text-darkPurple dark:text-white">Load from Saved</span>
        </div>

        <div className="mb-6 h-24 animate-pulse rounded-lg border border-purple-200 bg-purple-50 dark:border-purple-500/30 dark:bg-purple-900/30" />

        <div className="mb-6 grid grid-cols-2 gap-2 sm:grid-cols-4" aria-hidden="true">
          {[0, 1, 2, 3, 4, 5, 6, 7].map((step) => (
            <div key={step} className="h-11 animate-pulse rounded-md bg-slate-200 dark:bg-slate-700" />
          ))}
        </div>

        <section className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-800">
          <div className="h-6 w-48 animate-pulse rounded bg-slate-200 dark:bg-slate-700" />
          <div className="mt-5 h-28 animate-pulse rounded-md bg-slate-100 dark:bg-slate-700" />
          <div className="mt-4 h-10 w-36 animate-pulse rounded-md bg-slate-200 dark:bg-slate-700" />
        </section>
      </main>
      <FooterHome />
    </div>
  );
}
